// @flow

import updateEstimateOptionalField from '../../../Services/updateEstimateOptionalField';
import type { UpdateEstimateOptionalFieldParams } from '../../../types';

export default (params: UpdateEstimateOptionalFieldParams) => async (dispatch: Function) => dispatch(updateEstimateOptionalField(params));